module.exports = __webpack_public_path__ + "static/media/choose-plan-single-company.93ab920f.svg";